import React, {Component, PropTypes} from 'react'
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper'
import {Input} from 'react-bootstrap'
import style from './TypeaheadInput.less'

function escapeRegExp(value) {
    return value.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
}

export function matcher({source, identify=(v) => v}) {
    return (q, cb) => {
        var matches

        if (q) {
            const regexp = new RegExp(escapeRegExp(q), 'i')
            matches = source.filter((value) => regexp.test(identify(value)))
        } else {
            matches = source
        }

        cb(matches)
    }
}

export function multiMatcher(matchers) {
    return (q, cb) => {
        var result = []
        var count = matchers.length

        matchers.forEach((matcher) => {
            matcher(q, (matches) => {
                count--
                result.push(...matches)
                
                if (count == 0) {
                    cb(result)
                }
            })
        })
    }
}

class Typeahead extends Component {
    static propTypes = {
        source: PropTypes.func.isRequired,
        display: PropTypes.func,
        highlight: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        addonBefore: PropTypes.bool,
        addonAfter: PropTypes.bool
    }

    static defaultProps = {
        display: (v) => v
    }

    constructor(props) {
        super(props)

        this.state = {
            opened: false,
            matches: []
        }
    }

    componentWillMount() {
        const {source} = this.props

        source(null, (matches) => {
            this.setState({matches})
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.source != this.props.source) {
            const {source} = nextProps
   
            source(null, (matches) => {
                this.setState({
                    opened: false,
                    matches: matches,
                    query: null
                })
            })
        }
    }

    reset() {
        const {source} = this.props
        
        source(null, (matches) => {
            this.setState({
                opened: false,
                matches: matches,
                query: null
            })
        })
    }

    _match(event) {
        const {source} = this.props
        const query = event.target.value || null

        this.setState({query})

        source(query, (matches) => {
            const opened = matches.length > 0
            this.setState({opened, matches})
        })
    }

    _select(event, value) {
        const {onChange, display} = this.props

        event.preventDefault()
        this.setState({
            opened: false,
            query: display(value, 'Query'),
        })
        onChange(value)
    }

    _open() {
        const {matches} = this.state

        this.setState({
            opened: matches.length > 0
        })
    }

    _close() {
        this.setState({
            opened: false
        })
    }

    render() {
        const {children, source, display, highlight, value, onChange, addonBefore, addonAfter, ...others} = this.props
        const {opened, query, matches} = this.state

        const matchElement = (match, index) => {
            const html = highlight && highlight(match) || null
            const text = !html && display(match) || null

            return (
                <li key={index}>
                    <a
                        href=''
                        onClick={(e) => this._select(e, match)}
                        dangerouslySetInnerHTML={html}>
                        {text}
                    </a>
                </li>
            )
        }

        return (
            <div className={style.default}>
                <RootCloseWrapper noWrap
                    onRootClose={() => this._close()}>
                    <div>
                        <div className={style.inputGroup}>
                            {addonBefore && (<span />)}
                            <input
                                type='text'
                                value={query}
                                onFocus={(e) => this._open(e)}
                                onChange={(e) => this._match(e)}
                                {...others} />
                            {addonAfter && (<span />)}
                        </div>
                        {opened && (
                            <ul className={style.result}>
                                {matches.map(matchElement)}
                            </ul>
                        )}
                    </div>
                </RootCloseWrapper>
            </div>
        )
    }
}

class TypeaheadInput extends Component {

    reset() {
        const {typeahead} = this.refs
        typeahead.reset()
    }

    render() {
        const {source, display, highlight, onChange, placeholder, disabled, bsStyle, addonBefore, addonAfter, ...others} = this.props

        return (
            <Input
                addonBefore={addonBefore}
                addonAfter={addonAfter}
                {...others}>
                <Typeahead
                    ref='typeahead'
                    className='form-control'
                    source={source}
                    display={display}
                    highlight={highlight}
                    onChange={onChange}
                    placeholder={placeholder}
                    disabled={disabled}
                    addonBefore={addonBefore != null}
                    addonAfter={addonAfter != null} />
            </Input>
        )
    }
}

export {Typeahead}
export default TypeaheadInput


// WEBPACK FOOTER //
// ./lib/core/components/TypeaheadInput.js